export default "__VITE_ASSET__Bkdx$Ifh__"